// React
import { useState } from "react";
// Recoil
import { useResetRecoilState } from "recoil";
import { menuState } from "../../atom/pos";

function PosSaleList() {
  // 매출 조회 화면

  // Recoil State
  const resetMenuType = useResetRecoilState(menuState);

  const menuList = [
    "상품별",
    "분류별",
    "결제수단별",
    "판매자별",
    "당일 승인현황",
    "점검처리",
    "판매현황",
    "주문취소내역",
    "할인내역",
  ];
  const listTitle = [
    "No.",
    "상품명",
    "총수량",
    "총매출",
    "총할인",
    "순매출",
    "점유율",
  ];
  const listResult = [
    "합계",
    "1111",
    "111,111,111",
    "333,333",
    "111,111,111",
    "100%",
  ];
  const orderList = [
    {
      name: "콜라",
      ea: 15,
      amount: 752000,
      sale: 12510,
      total: 1054000,

      percent: 50,
    },
    {
      name: "아메리카노",
      ea: 25,
      amount: 952000,
      sale: 22510,
      total: 5054000,
      percent: 80,
    },
  ];
  const listTitle2 = [
    "No.",
    "영업일자",
    "총수량",
    "총매출",
    "총할인",
    "순매출",
    "점유율",
  ];
  const orderList2 = [
    {
      date: "2022-10-06",
      ea: 15,
      amount: 752000,
      sale: 12510,
      total: 1054000,
      percent: 50,
    },
    {
      date: "2022-10-08",
      ea: 25,
      amount: 952000,
      sale: 22510,
      total: 5054000,
      percent: 80,
    },
  ];

  return (
    <div className='pos-popup-bg'>
      <div className='pos-popup-menu-wrap'>
        <div className='popup-head'>
          <div>매출조회</div>
          <div
            className='close-box'
            onClick={() => {
              resetMenuType();
            }}
          >
            <img
              className='icon'
              src={"/assets/images/pos/close.svg"}
              alt='reauest'
              width={"100%"}
              height={"100%"}
            />
          </div>
        </div>
        <div className='popup-menu-body-wrap'>
          <div className='body-left'>
            {menuList.map((v, idx) =>
              idx === 0 ? (
                <div className='menu-box menu-active'>
                  <span>{v}</span>
                  <div className='bar'></div>
                </div>
              ) : (
                <div className='menu-box'>
                  <span>{v}</span>
                  <div className='bar'></div>
                </div>
              )
            )}
          </div>
          <div className='body-right'>
            <div className='flex col'>
              <div className='salse-menu-row'>
                <div className='flex col' style={{ width: "130%" }}>
                  <div className='menu-title'>영업일자</div>
                  <div className='salse-menu-row align-items-center'>
                    <div className='filter-box'>
                      <img
                        src={"/assets/images/pos/calender.svg"}
                        alt=''
                        width={"26px"}
                        height={"26px"}
                      />
                      <span>2022-10-08</span>
                    </div>
                    ~
                    <div className='filter-box'>
                      <img
                        src={"/assets/images/pos/calender.svg"}
                        alt=''
                        width={"26px"}
                        height={"26px"}
                      />
                      <span>2022-10-08</span>
                    </div>
                  </div>
                </div>
                <div className='flex col' style={{ width: "70%" }}>
                  <div className='menu-title'>기기 번호</div>
                  <div
                    className='salse-menu-row align-items-center'
                    style={{ gap: 0 }}
                  >
                    <div className='filter-box'>브이디메뉴11</div>
                    <div
                      className='filter-box'
                      style={{
                        aspectRatio: "1/1",
                        width: "fit-content",
                        borderLeft: "none",
                      }}
                    >
                      <img
                        src={"/assets/images/pos/arrow_down.svg"}
                        alt=''
                        width={"26px"}
                        height={"26px"}
                      />
                    </div>
                  </div>
                </div>
                <div className='flex col'>
                  <div className='menu-title'>테이블</div>
                  <div
                    className='salse-menu-row align-items-center'
                    style={{ gap: 0 }}
                  >
                    <div className='filter-box'>011</div>
                    <div
                      className='filter-box'
                      style={{
                        aspectRatio: "1/1",
                        width: "fit-content",
                        borderLeft: "none",
                      }}
                    >
                      <img
                        src={"/assets/images/pos/arrow_down.svg"}
                        alt=''
                        width={"26px"}
                        height={"26px"}
                      />
                    </div>
                    <div
                      className='filter-btn find'
                      style={{ marginLeft: "0.4rem" }}
                    >
                      조회
                    </div>
                    <div
                      className='filter-btn'
                      style={{ marginLeft: "0.4rem" }}
                    >
                      인쇄
                    </div>
                  </div>
                </div>
              </div>
              <div className='sales-list-wrap'>
                <div className='popup-table'>
                  <div className='list-row'>
                    {listTitle.map((v) => (
                      <div>{v}</div>
                    ))}
                  </div>
                  {orderList.map((v, i) => (
                    <div className='list'>
                      <div>{i + 1}</div>
                      <div>{v.name}</div>
                      <div>{v.ea}</div>
                      <div>{v.amount.toLocaleString()}</div>
                      <div>{v.sale.toLocaleString()}</div>
                      <div>{v.total.toLocaleString()}</div>
                      <div>{v.percent}%</div>
                    </div>
                  ))}
                </div>
                <div className='list-result-row'>
                  {listResult.map((v) => (
                    <div>{v}</div>
                  ))}
                </div>
              </div>
            </div>
            <div className='flex col'>
              <div className='menu-title'>일자별 상세내역</div>
              <div className='sales-list-wrap'>
                <div className='popup-table'>
                  <div className='list-row'>
                    {listTitle2.map((v) => (
                      <div>{v}</div>
                    ))}
                  </div>
                  {orderList2.map((v, i) => (
                    <div className='list'>
                      <div>{i + 1}</div>
                      <div>{v.date}</div>
                      <div>{v.ea}</div>
                      <div>{v.amount.toLocaleString()}</div>
                      <div>{v.sale.toLocaleString()}</div>
                      <div>{v.total.toLocaleString()}</div>
                      <div>{v.percent}%</div>
                    </div>
                  ))}
                </div>
                <div className='list-result-row'>
                  {listResult.map((v) => (
                    <div>{v}</div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
function PosMenuControl() {
  // 통합 관리 화면

  // Recoil State
  const resetMenuType = useResetRecoilState(menuState);
  // useState
  const [exitPopup, setExitPopup] = useState<boolean>(false);
  const menuList = ["브이디메뉴 영업관리", "설정"];
  const listTitle = [
    "No.",
    "테이블명",
    "브이디메뉴 현재상태",
    "종료",
    "주문 상태",
  ];
  const orderList = [
    { name: "1층 - 1", state: "판매 중" },
    { name: "1층 - 2", state: "판매 마감" },
    { name: "2층 - 1", state: "판매 마감" },
    { name: "2층 - 2", state: "판매 마감" },
  ];

  return (
    <div className='pos-popup-bg'>
      <div className='pos-popup-control-wrap'>
        <div className='popup-head'>
          <div>브이디메뉴 관리</div>
          <div
            className='close-box'
            onClick={() => {
              resetMenuType();
            }}
          >
            <img
              className='icon'
              src={"/assets/images/pos/close.svg"}
              alt='reauest'
              width={"100%"}
              height={"100%"}
            />
          </div>
        </div>
        <div className='popup-control-body-wrap'>
          <div className='body-left'>
            {menuList.map((v, idx) =>
              idx === 0 ? (
                <div className='menu-box menu-active'>
                  <span>{v}</span>
                  <div className='bar'></div>
                </div>
              ) : (
                <div className='menu-box'>
                  <span>{v}</span>
                  <div className='bar'></div>
                </div>
              )
            )}
          </div>
          <div className='body-right'>
            <div className='salse-menu-row'>
              <div className='flex col' style={{ width: "fit-content" }}>
                <div className='menu-title'>영업일자</div>
                <div
                  className='salse-menu-row align-items-center'
                  style={{ gap: 0 }}
                >
                  <div className='filter-box' style={{ width: "170px" }}>
                    2022-10-06
                  </div>
                </div>
              </div>
              <div className='flex col'>
                <div className='menu-title'>브이디 메뉴 자동 마감 시간</div>
                <div
                  className='salse-menu-row align-items-center'
                  style={{ gap: 0 }}
                >
                  <div className='filter-box' style={{ width: "170px" }}>
                    22: 00
                  </div>
                  <div className='filter-btn find'>영업시작</div>
                  <div className='filter-btn' style={{ marginLeft: "0.4rem" }}>
                    메뉴끄기
                  </div>
                </div>
              </div>
            </div>
            <div className='sales-list-wrap'>
              <div className='menu-title' style={{ marginTop: "26px" }}>
                브이디메뉴 수동 설정
              </div>
              <div
                className='popup-table'
                style={{ borderBottom: "1px solid #D4D4D4" }}
              >
                <div className='list-row'>
                  {listTitle.map((v) => (
                    <div>{v}</div>
                  ))}
                </div>
                {orderList.map((v, i) => (
                  <div className='list'>
                    <div>{i + 1}</div>
                    <div>{v.name}</div>
                    <div>{v.state}</div>
                    <div>
                      <div className='inner-btn' style={{ margin: "auto" }}>
                        종료
                      </div>
                    </div>
                    <div>
                      <div className='inner-btn' style={{ margin: "auto" }}>
                        중지
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className='flex row' style={{ justifyContent: "flex-end" }}>
              <div className='exit-btn'>시스템 종료</div>
              <div
                className='all-exit-btn pointer'
                onClick={() => {
                  setExitPopup(true);
                }}
              >
                전부 종료
              </div>
            </div>
          </div>
        </div>
      </div>
      {exitPopup && <ResPopup setExitPopup={setExitPopup} />}
    </div>
  );
}

interface Props {
  setExitPopup: React.Dispatch<React.SetStateAction<boolean>>;
}
function ResPopup(props: Props) {
  // 종료  팝업

  return (
    <div className='res-popup-wrap' style={{ width: "40%" }}>
      <div className='popup-head'>
        <div>전체종료</div>
      </div>
      <div className='res-popup-body'>
        <div className='res-popup-stop-box'>
          브이디메뉴를 전체 종료하시겠습니까?
        </div>
        <div className='flex row' style={{ gap: "1.1rem" }}>
          <div
            className='stop-order'
            onClick={() => {
              props.setExitPopup(false);
            }}
          >
            주문 그만 받기
          </div>
          <div
            className='exit-all pointer'
            onClick={() => {
              props.setExitPopup(false);
            }}
          >
            종료
          </div>
        </div>
      </div>
    </div>
  );
}
export { PosSaleList, PosMenuControl };
